// extracted by mini-css-extract-plugin
export var container = "Navigation-module--container--2jyqo";
export var navigation = "Navigation-module--navigation--1PDAE";
export var logo = "Navigation-module--logo--2uVHo";
export var logo__hover = "Navigation-module--logo__hover--35tJX";
export var logo__icon = "Navigation-module--logo__icon--mY7DQ";